import { Calendar } from './calendar.model';

export const defaultProjectCalendar = new Calendar({
    workingDaysOfWeek: [1, 2, 3, 4, 5],
    workingHoursPerDay: 8,
    isDefault: true,
});
